module.exports = __webpack_public_path__ + "static/media/squooshed5.e041fe6b.jpeg";